var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c0e8a6c03d3b960d9a40a2bf20fba88cd08a33d8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@grailed"]={id:"c0e8a6c03d3b960d9a40a2bf20fba88cd08a33d8"};
      